import apiFetch from '../apiFetch'

export default function (idPoolExtraccion, token) {
  return apiFetch({endPoint: `Pool/eliminarPool?idPool=` + idPoolExtraccion, method: 'GET', body: null, token: token})
}
